import { UserPermission } from './_props'
import useCurrentHcs from './useCurrentHcs'

export type UserPermissionCode = 0 | 1 | 2
export const userPermissionsRecord: Record<UserPermission, UserPermissionCode> = {
    USER: 2,
    ADMIN: 1,
    'SUPER ADMIN': 0,
}

const useUserPermissions = () => {
    const { currentUserDelegateRole } = useCurrentHcs()

    if (!currentUserDelegateRole) {
        console.error('[useUserPermissions] user must have a delegate role')
        throw new Error('user must have a delegate role')
    }

    const code = currentUserDelegateRole.code

    const hasUserPermission = (permission: UserPermission | UserPermissionCode) => {
        if (typeof permission === 'number') {
            return code <= permission
        }
        return code <= userPermissionsRecord[permission]
    }
    return { hasUserPermission }
}

export default useUserPermissions
